<template>
  <div class="p-12 max-w-5xl mx-auto">
    <div class="space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500">
          {{ title }}
        </h4>
        <div>
          <CreateNewProjectAction
            v-if="$membershipHasPermissionTo('create projects')"
            :account-id="accountId"
          />
        </div>
      </div>

      <div class="space-y-8">
        <BasePaginator :disabled="pending" :meta="meta" @change="changePage" />

        <div v-if="pending" class="px-4 text-center">
          <Loader />
        </div>

        <BaseGrid v-else :columns="3">
          <template v-for="project in projects">
            <ProjectCard :key="project.uuid" :project="project" />
          </template>
        </BaseGrid>

        <BasePaginator :disabled="pending" :meta="meta" @change="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ProjectCard from '@/components/AccountProjects/ProjectCard.vue';
import CreateNewProjectAction from './components/CreateNewProjectAction.vue';

export default {
  components: {
    CreateNewProjectAction,
    ProjectCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    pending: false,
  }),
  computed: {
    ...mapState('ui/accountProjects', ['meta']),
    ...mapGetters('ui/accountProjects', ['projects']),
    title() {
      const { productCategory = '' } = this.$route.params;

      switch (productCategory) {
        case 'tactics':
          return 'Tactics';
        case 'bulk-messages':
          return 'Bulk Messages';
        case 'posts':
          return 'Posts';
        default:
          return 'Projects';
      }
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/accountProjects', ['fetchAccountProjectList']),
    ...mapMutations('ui/accountProjects', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { accountId } = this.$route.params;
      const { query } = this.$route;
      this.pending = true;
      try {
        await this.fetchAccountProjectList({
          accountId,
          params: {
            ...query,
            filter: {
              product_category_is: this.productCategory || undefined,
            },
            include: 'channable_insights,cover,contactRequestsCount',
          },
        });
      } catch (error) {
        //
      }
      this.pending = false;
    },
    changePage(page) {
      const { currentRoute } = this.$router;

      this.$router.push({
        ...currentRoute,
        query: {
          page,
        },
      });
    },
  },
};
</script>
